/**
 * Takes a datetime string like "2023-08-15T12:08:00" and returns a separate
 * string for the date and the time: ["2023-08-15", "12:08:00"].
 */
export default (val: string | undefined) => {
  if (val) {
    if (val.startsWith('T')) {
      return ['', val.replace('Z', '').replace('T', '')];
    }
    else {
      return val.replace('Z', '').split('T') as [string, string];
    }
  }
  return ['', ''];
};
